import React from 'react';
import ReactMarkdown from 'react-markdown';

import { App } from '@meronex/app';
import MdArrowBack from '@meronex/icons/md/MdArrowBack';

import { Link } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
    backgroundColor: 'rgb(14, 14, 14)',
    height: '60px',
    color: theme.appBar.color,
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const ChangelogDialog = () => {
  const classes = useStyles();
  const [changelog, setChangelog] = React.useState(undefined);

  const [open, setOpen] = React.useState(false);

  const fetchChangelog = async () => {
    if (!changelog) {
      try {
        const response = await fetch(App.hostUrl.fullHost + '/CHANGELOG.md');
        const text = await response.text();
        setChangelog(text);
      } catch (e) {
        console.log(e);
      }
    }
  };

  const openDialog = () => {
    fetchChangelog();
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };
  React.useEffect(() => {
    App.eventsManager.on('event-open-changelog', ChangelogDialog.name, () => {
      openDialog();
    });
    return () => {
      App.eventsManager.removeListener(
        'event-open-changelog',
        this,
        openDialog
      );
    };
  }, []);

  let cleanedChangelog = '';
  if (changelog) {
    const regex = /\(\[(.*?)\]\(.*?\)\)/g;
    cleanedChangelog = changelog.replace(regex, '');
    console.log(cleanedChangelog);
  }
  return (
    <Dialog
      fullScreen={!!App.utils.isMobile()}
      fullWidth
      maxWidth={'md'}
      open={open}
      onClose={() => onClose()}
      TransitionComponent={Transition}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => {
              onClose();
            }}
            aria-label="close">
            <MdArrowBack />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            Changelog
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper
        style={{
          padding: '10px',
        }}>
        {!changelog && <div>Loading...</div>}
        {changelog && (
          <ReactMarkdown
            source={cleanedChangelog}
            skipHtml={true}
            renderers={{
              link: (props) => {
                console.log(props);
                return <Link href={'#'}>{props.children}</Link>;
              },
            }}
          />
        )}
      </Paper>
    </Dialog>
  );
};
